import Row from './Row'


const HeaderColumn = (props) => {
  const title = props._title
  const border = props._border
  return (
    <div className={'w-100 pa2 dark-gray white tc f7 ' + (border ? ' bl ' : '') } style={{background: '#8a8171'}}>
    {/* <div className='w-100 pa2 dark-gray white tc bg-black f6' > */}
      {title}
    </div>
  )
}

const Results = (props) => {
  return (
    <div className='flex flex-column'>
      <div className='flex'>
        {/* <div className='w-30 bg-dark-gray flex flex-column' >  style={{background: '#a19a8d'}}> */}
        <div className='w-40 bg-dark-gray flex flex-column' > 
          <div className='pa3 white fw4 f6 fw7 tc '>Shipment Results</div>
          <div className='w-100 flex'>
            <HeaderColumn _title='Test'/>
            <HeaderColumn _title='Percent' />
          </div>
        </div>

          <div className='w-40 ' >
            <div className='w-100 bg-dark-gray bl b--white' >
              <div className='pa3 white fw7 f6 tc '>Claim Results (12% Basis)</div>

            </div>
            <div className='w-100 flex b--white'>
                <HeaderColumn _title='Percent'/>
                <HeaderColumn _title='Dollars'/>
              </div>
          </div>
          <div className='w-20 ' >
            <div className='w-100 bg-dark-gray bl b--white' >
              <div className='pa3 white fw4 fw7 f6 tc'>Referee (12% Basis)</div>
      
            </div>
            <div className='flex'>
              <HeaderColumn _title='Percent'/>
              {/* <HeaderColumn _title='Remarks'/> */}
              {/* <HeaderColumn _title='Attach File'/> */}
            </div>
        </div>


        
      </div>
        <Row _test='Protein' _top={true} {...props}/>
        <Row _test='Moisture' _even={true} {...props}/>
        <Row _test='Fiber' _bottom={true} {...props}/>
    </div>
  )
}

export default Results